import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core'

@Directive({
  selector: '[autofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  private el = inject(ElementRef)

  ngAfterViewInit() {
    window.setTimeout(() => {
      this.el.nativeElement.focus()
    })
  }
}
